import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { ManageDocketTemplateRootParamList } from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ManageDocketTemplateScreen } from "../ManageDocketTemplateScreen";
import { ManageDocketTemplateFilterRootScreen } from "../ManageDocketTemplateFilterRootScreen";

const Stack = createStackHeaderNavigator<ManageDocketTemplateRootParamList>();

export interface ManageDocketTemplateRootScreenProps
  extends StackScreenProps<any, "ManageDocketTemplateRootScreen"> {}

export const ManageDocketTemplateRootScreen =
  ({}: ManageDocketTemplateRootScreenProps) => {
    return (
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
        }}
      >
        <Stack.Group
          screenOptions={{
            headerShown: true,
            title: "",
            headerLeft: () => <ModalCloseButton type="Back" />,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Stack.Screen
            name="ManageDocketTemplateScreen"
            component={ManageDocketTemplateScreen}
          />
        </Stack.Group>
        <Stack.Group
          screenOptions={{ headerShown: false, presentation: "modal" }}
        >
          <Stack.Screen
            name="ManageDocketTemplateFilterRootScreen"
            component={ManageDocketTemplateFilterRootScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    );
  };
